import(/* webpackMode: "eager" */ "/app/apps/ui/src/app/timeline/page.tsx");
